import { useEffect, useRef, useState } from 'react'
import { DOM_EVENT, KEYBOARD_KEY } from '@/shared/constants/keyboard'

export function useProfileMenu() {
  const [isOpen, setIsOpen] = useState(false)
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!isOpen) return
    function handleClickOutside(e: MouseEvent) {
      if (!containerRef.current?.contains(e.target as Node)) setIsOpen(false)
    }
    function handleKeyDown(e: KeyboardEvent) {
      if (e.key === KEYBOARD_KEY.ESCAPE) setIsOpen(false)
    }
    document.addEventListener(DOM_EVENT.MOUSEDOWN, handleClickOutside)
    document.addEventListener(DOM_EVENT.KEYDOWN, handleKeyDown)
    return () => {
      document.removeEventListener(DOM_EVENT.MOUSEDOWN, handleClickOutside)
      document.removeEventListener(DOM_EVENT.KEYDOWN, handleKeyDown)
    }
  }, [isOpen])

  function toggleMenu() {
    setIsOpen((prev) => !prev)
  }

  return { isOpen, toggleMenu, containerRef }
}
